import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clamp } from '@nu-art/ts-common';
import * as React from 'react';
import { ComponentSync } from '../../core/ComponentSync.js';
import './TS_ProgressBar.scss';
import { _className } from '../../utils/tools.js';
export class TS_ProgressBar extends ComponentSync {
    static defaultProps = {
        type: 'linear-bar',
        radius: 30,
    };
    deriveStateFromProps(nextProps, state) {
        const ratios = nextProps.ratios.map(ratio => clamp(0, ratio, 1));
        state.percentages = ratios.map(ratio => Math.floor(ratio * 100));
        return state;
    }
    getRenderer() {
        switch (this.props.type) {
            case 'linear-bar':
                return this.renderLinearBar;
            case 'radial':
                return this.renderRadialBar;
        }
    }
    renderLinearBar = () => {
        return _jsx("div", { className: 'ts-progress-bar__linear-bar', children: this.state.percentages.map((percentage, i) => {
                return _jsxs(React.Fragment, { children: [_jsxs("div", { className: 'ts-progress-bar__linear-bar__text', children: [percentage, "%"] }), _jsx("div", { className: 'ts-progress-bar__linear-bar__bar', style: { width: `${percentage}%` }, children: _jsxs("div", { className: 'ts-progress-bar__linear-bar__text', children: [percentage, "%"] }) })] }, i);
            }) });
    };
    renderRadialBar = () => {
        const radius = this.props.radius;
        const strokeDashArray = 2 * Math.PI * radius;
        const lastPercentage = this.state.percentages[this.state.percentages.length - 1];
        return _jsxs("div", { className: 'ts-progress-bar__radial-bar', children: [_jsxs("div", { className: 'ts-progress-bar__radial-bar__text', children: [lastPercentage, "%"] }), _jsxs("svg", { className: "ts-progress-bar__radial-bar__bar", viewBox: '0 0 100 100', children: [_jsx("circle", { cx: "50", cy: "50", r: radius, className: 'ts-progress-bar__radial-bar__bar__background' }), this.state.percentages.map((percentage, i) => {
                            const strokeDashOffset = strokeDashArray - (strokeDashArray * this.props.ratios[i]);
                            return _jsx("circle", { cx: "50", cy: "50", r: radius, className: `ts-progress-bar__radial-bar__bar-child-${i}`, strokeDasharray: strokeDashArray, strokeDashoffset: strokeDashOffset }, i);
                        })] })] });
    };
    render() {
        const className = _className('ts-progress-bar', this.props.className);
        const Renderer = this.getRenderer();
        return _jsx("div", { className: className, onClick: this.props.onClick, children: _jsx(Renderer, {}) });
    }
}
//# sourceMappingURL=TS_ProgressBar.js.map